import React, { useState } from 'react';

import { notification } from 'antd';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import { useUpdateCreditNote } from '@hooks/API/UseCreditNotes';
import { useUpdateInvoice } from '@hooks/API/UseInvoices';

import { NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';
import { NWInput, NWTextAreaCharCounter } from '@components/Gui/NwForm/NwFormItems';
import { NwForm, NwFormButtonsBar } from '@components/Gui/NwForm/NwFormWrapper';

const EditTextsDrawer = ({ onClose, data }) => {
    const [touchForm, setTouchForm] = useState(false);
    const { mutateAsync: onUpdateInvoice } = useUpdateInvoice();
    const { mutateAsync: onUpdateCreditNote } = useUpdateCreditNote();
    const isCreditNote = data.TypeName.includes('Credit');

    const initialValues = {
        ObjectName: data.Name,
        HeaderNote: data.HeaderNote ? data.HeaderNote : '',
        AddressNote: data.AddressNote ? data.AddressNote : '',
        FooterNote: data.FooterNote ? data.FooterNote : '',
    };
    if (isCreditNote) {
        initialValues.CreditNoteID = data.ID;
    } else {
        initialValues.InvoiceID = data.ID;
    }

    const UpdateInvoiceOrCreditNote = async (values, setSubmitting) => {
        setSubmitting(true);
        try {
            if (isCreditNote) {
                await onUpdateCreditNote({
                    data: {
                        ...values,
                        Name: values.ObjectName,
                    },
                });
            } else {
                await onUpdateInvoice({
                    data: {
                        ...values,
                        Name: values.ObjectName,
                    },
                });
            }
            onClose();
        } catch (e) {
            notification.error({
                message: 'Error',
                description: 'Error updating invoice / credit note',
            });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <NwDrawer
            touchForm={touchForm}
            onTouchForm={setTouchForm}
            onClose={onClose}
            title="Edit Invoice / Credit Note Details"
        >
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    UpdateInvoiceOrCreditNote(values, setSubmitting);
                }}
                validationSchema={Yup.object().shape({
                    ObjectName: Yup.string().required('A name is required'),
                })}
            >
                {({ isSubmitting, values, handleSubmit }) => (
                    <NwForm values={values} onTouchForm={setTouchForm} onFinish={handleSubmit}>
                        <Field
                            component={NWInput}
                            label="Name"
                            name="ObjectName"
                            maxLength={50}
                            type="text"
                            value={values.ObjectName}
                        />
                        <Field
                            component={NWTextAreaCharCounter}
                            label="Description"
                            name="HeaderNote"
                            maxLength={600}
                            type="text"
                            value={values.HeaderNote}
                        />
                        {!isCreditNote && (
                            <>
                                <Field
                                    component={NWTextAreaCharCounter}
                                    label="Address Additional Text"
                                    name="AddressNote"
                                    maxLength={600}
                                    type="text"
                                    value={values.AddressNote}
                                />
                            </>
                        )}
                        <Field
                            component={NWTextAreaCharCounter}
                            label="Terms Additional Text"
                            name="FooterNote"
                            maxLength={600}
                            type="text"
                            value={values.FooterNote}
                        />
                        <br />
                        <br />
                        <NwFormButtonsBar
                            left={
                                <NwCancelButton
                                    disabled={isSubmitting}
                                    onClick={() => {
                                        setTouchForm(false);
                                        onClose();
                                    }}
                                />
                            }
                            right={<NwSaveButton htmlType="submit" disabled={isSubmitting} loading={isSubmitting} />}
                        />
                    </NwForm>
                )}
            </Formik>
        </NwDrawer>
    );
};

export default EditTextsDrawer;
